// extracted by mini-css-extract-plugin
export default {"Field":"DesignTextsSection_Field__poJH5","Label":"DesignTextsSection_Label__gcSjI","TextInput":"DesignTextsSection_TextInput__IJS3K","List":"DesignTextsSection_List__vOxiG"};